module.exports = __webpack_public_path__ + "b939d4e8b0dd91a06b6a01d6fbf2e3d6.svg";